import { Gem, Heart, Shield, Users } from "lucide-react";
const LOGO_URL = "/images/full-logo.png";

const About = () => {
  return (
    <div data-testid="about-page" className="min-h-screen bg-ivory pt-24">
      {/* Hero */}
      <section className="py-20 bg-gradient-to-b from-champagne-light to-cream">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="font-display text-xs tracking-[0.4em] uppercase text-royal-gold mb-4">Est. Manekchowk</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-charcoal mb-6">Our <span className="text-gold-gradient">Heritage</span></h1>
          <p className="font-body text-charcoal/60 max-w-xl mx-auto">A legacy of excellence in silver craftsmanship</p>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 bg-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="luxury-frame p-8 bg-gradient-to-br from-champagne-light to-cream">
              <img src={LOGO_URL} alt="Shree Ganesh Ornaments" className="w-full mx-auto" />
            </div>
            <div className="space-y-6">
              <p className="font-display text-xs tracking-[0.4em] uppercase text-royal-gold">The Legacy</p>
              <h2 className="font-serif text-3xl text-charcoal">Welcome to <span className="text-gold-gradient">Shree Ganesh Ornaments</span></h2>
              <p className="font-body text-charcoal/70 leading-relaxed">Nestled in the historic heart of Manekchowk, Ahmedabad's legendary jewellery bazaar, Shree Ganesh Ornaments stands as a beacon of excellence in silver craftsmanship.</p>
              <p className="font-body text-charcoal/70 leading-relaxed">Every piece carries the essence of traditional Indian artistry, harmoniously blended with contemporary elegance. We cater to both individual collectors and wholesale traders.</p>
              <p className="font-body text-charcoal/70 leading-relaxed">Our commitment to purity, fair dealing, and customer satisfaction has established us as the trusted name in Gujarat's silver jewellery landscape.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-gradient-to-b from-pearl to-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="font-display text-xs tracking-[0.4em] uppercase text-royal-gold mb-4">Our Foundation</p>
            <h2 className="font-serif text-3xl text-charcoal">The <span className="text-gold-gradient">Pillars</span> We Stand Upon</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: Shield, title: "Trust", desc: "Transparency and integrity in every transaction" },
              { icon: Gem, title: "Quality", desc: "Finest 925 sterling silver, meticulous craftsmanship" },
              { icon: Heart, title: "Passion", desc: "Deep love for the art of jewellery making" },
              { icon: Users, title: "Service", desc: "Dedicated support for all customers" },
            ].map((v, i) => (
              <div key={i} className="text-center p-8 bg-white border border-gold-muted/10 hover:border-royal-gold/30 transition-all">
                <div className="w-14 h-14 mx-auto mb-6 border border-royal-gold/30 flex items-center justify-center">
                  <v.icon size={24} className="text-royal-gold" />
                </div>
                <h3 className="font-display text-sm tracking-[0.2em] uppercase text-charcoal mb-2">{v.title}</h3>
                <p className="font-body text-sm text-charcoal/50">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Visit */}
      <section className="py-20 bg-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="font-display text-xs tracking-[0.4em] uppercase text-silver-dark">Why Us</p>
              <h2 className="font-serif text-3xl text-charcoal">The <span className="text-gold-gradient">Distinction</span></h2>
              <ul className="space-y-4">
                {["Prime location in Manekchowk, Ahmedabad", "Extensive retail and wholesale collection", "Transparent pricing, no hidden costs", "Expert guidance and personalized service", "Certified quality assurance", "Trusted across Gujarat"].map((p, i) => (
                  <li key={i} className="flex items-start space-x-3"><span className="w-1 h-6 bg-royal-gold flex-shrink-0" /><span className="font-body text-charcoal/70">{p}</span></li>
                ))}
              </ul>
            </div>
            <div className="bg-gradient-to-br from-champagne-light to-champagne p-8 border border-gold-muted/20">
              <p className="font-display text-xs tracking-[0.4em] uppercase text-royal-gold mb-4">Visit Our Showroom</p>
              <h3 className="font-serif text-xl text-charcoal mb-6">Shree Ganesh Ornaments</h3>
              <div className="space-y-3 font-body text-charcoal/70 text-sm">
                <p>1396, Devadinni Pole, Rangati Bajar Road,<br />M.G Haveli Road, Manekchowk,<br />Ahmedabad – 380001</p>
                <p className="pt-4"><span className="text-royal-gold">Call:</span> <a href="tel:+919104054259" className="hover:text-royal-gold">+91 9104054259</a></p>
                <p><span className="text-royal-gold">WhatsApp:</span> <a href="https://wa.me/919104054259" className="hover:text-royal-gold">+91 9104054259</a></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
